<label class="LayerVisibilityCheckbox"><input type="checkbox" v-model="visible"/><span>{{getLabel()}}</span></label>